























import {Component, Prop, Vue} from 'vue-property-decorator';
import RegisterCall from "@/components/register/Call.vue";
import RegisterCode from "@/components/register/Code.vue";

@Component({
    components:{
        RegisterCall,
        RegisterCode,
    }
})

export default class Verification extends Vue {
    private inputPhoneNumber = '';
    private inputConfirm = false;
    private inputRequestId: string | null = null;

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    getInputConfirm(confirm: boolean){
        this.inputConfirm = confirm;
    }

    getPhoneNumber(inputPhoneNumber: string) {
        this.inputPhoneNumber = inputPhoneNumber;
    }

    getRequestId(requestId: string) {
        this.inputRequestId = requestId;
    }
}
